import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { Box, Button, Typography } from '@mui/material';
import PropTypes from 'prop-types';

import { closeDialogAction } from 'store/global/actions';

import { DisclosureDeliveryTestIds } from '../../DisclosureDelivery.testIds';

const ResendPackagePopup = ({ bundleName, onConfirm }) => {
  const dispatch = useDispatch();

  const onSubmit = useCallback(() => {
    onConfirm();

    dispatch(closeDialogAction());
  }, [dispatch, onConfirm]);

  const onCancel = useCallback(() => dispatch(closeDialogAction()), [dispatch]);

  return (
    <Box className="flex flex-col items-stretch">
      <Typography className="max-w-360" variant="regular14">
        Resending {bundleName || 'this package'} re-generates the documents and emails them again to
        all signers on the package. Previous delivery timestamps are reset. Continue?
      </Typography>
      <Box className="pt-16 self-end flex gap-8">
        <Button
          data-testid={DisclosureDeliveryTestIds.RESEND_CANCEL_BUTTON}
          variant="outlined"
          onClick={onCancel}
        >
          Cancel
        </Button>
        <Button
          data-testid={DisclosureDeliveryTestIds.RESEND_CONFIRM_BUTTON}
          variant="contained"
          onClick={onSubmit}
        >
          Resend package
        </Button>
      </Box>
    </Box>
  );
};

ResendPackagePopup.propTypes = {
  onConfirm: PropTypes.func.isRequired,
  bundleName: PropTypes.string,
};

export default ResendPackagePopup;
